module.exports = __webpack_public_path__ + "static/media/ryan_bishop_fun.622902c1.png";